export const FETCH_SUGGESTIONS_REQUEST = Symbol('API/SEARCH_SUGGESTIONS/FETCH_SUGGESTIONS_REQUEST');
export const FETCH_SUGGESTIONS_SUCCESS = Symbol('API/SEARCH_SUGGESTIONS/FETCH_SUGGESTIONS_SUCCESS');
export const FETCH_SUGGESTIONS_FAILURE = Symbol('API/SEARCH_SUGGESTIONS/FETCH_SUGGESTIONS_FAILURE');
